import React, { useState, useEffect } from "react"
import { Link, useNavigate } from "react-router-dom"

const Navbar = ({ page }) => {
  // const [login, setLogin] = useState(false);
  const [openNavbar, setOpenNavbar] = useState(false)
  const navigate = useNavigate()

  const handleClick = () => {
    setOpenNavbar(!openNavbar)
  }

  useEffect(() => {
    if (openNavbar) {
      document.body.style.overflow = "hidden" // Disable scrolling
    } else {
      document.body.style.overflow = "" // Enable scrolling
    }
    return () => {
      document.body.style.overflow = ""
    }
  }, [openNavbar])

  // useEffect(()=>{
  //   setLogin(false);
  // },[]);

  return (
    <nav className="navbar">
      <div className="navbar__box">
        <Link 
          to="/" 
          className="navbar__logo-link"
          onClick={() => {
            // Ensure navigation works from any page, including 404
            navigate("/", { replace: true })
          }}
        >
          <img
            src="/images/Newlogo.webp"
            alt="Pulpit cab service logo - Premium taxi booking platform"
            className="navbar__logo"
          />
        </Link>
        <ul className="navbar__menu" aria-label="Main navigation">
          {/* <li className="navbar__menu-item">
            <Link
              to="/"
              className={`navbar__menu-link ${
                page === "home" ? "navbar__menu__active" : ""
              }`}
            >
              Rider
            </Link>
          </li> */}
          <li className="navbar__menu-item">
            <Link
              to="/cab-driver-registration/"
              className={`navbar__menu-link ${
                page === "partner" ? "navbar__menu__active" : ""
              }`}
            >
              Partner
            </Link>
          </li>
          <li className="navbar__menu-item">
            <Link
              to="/corporate-cab-services/"
              className={`navbar__menu-link ${
                page === "corporate" ? "navbar__menu__active" : ""
              }`}
            >
              Corporate {/*  Business */}
            </Link>
          </li>
          <li className="navbar__menu-item">
            <Link
              to="/blogs/"
              className={`navbar__menu-link ${
                page === "blog" ? "navbar__menu__active" : ""
              }`}
            >
              Blogs
            </Link>
          </li>
          <li className="navbar__menu-item">
            <Link
              to="/about-us/"
              className={`navbar__menu-link ${
                page === "about-us" ? "navbar__menu__active" : ""
              }`}
            >
              About Us
            </Link>
          </li>
          <li className="navbar__menu-item">
            <a
              href="https://support.pulpitcabs.com"
              className={`navbar__menu-link ${
                page === "support" ? "navbar__menu__active" : ""
              }`}
            >
              Support
            </a>
          </li>
        </ul>
        {openNavbar && (
          <div className="navbar__mobile">
            <ul className="navbar__mobile-menu" aria-label="Main navigation">
              <li className="navbar__mobile-menu-item">
                <Link
                  to="/"
                  className={`navbar__mobile-menu-link ${
                    page === "home" ? "navbar__mobile-menu__active" : ""
                  }`}
                >
                  Rider
                </Link>
              </li>
              <li className="navbar__mobile-menu-item">
                <Link
                  to="/cab-driver-registration/"
                  className={`navbar__mobile-menu-link ${
                    page === "partner" ? "navbar__mobile-menu__active" : ""
                  }`}
                >
                  Partner
                </Link>
              </li>
              <li className="navbar__mobil-menu-item">
                <Link
                  to="/corporate-cab-services/"
                  className={`navbar__mobile-menu-link ${
                    page === "corporate" ? "navbar__mobile-menu__active" : ""
                  }`}
                >
                  Corporate
                </Link>
              </li>
              <li className="navbar__mobile-menu-item">
                <Link
                  to="/blogs/"
                  className={`navbar__mobile-menu-link ${
                    page === "blog" ? "navbar__mobile-menu__active" : ""
                  }`}
                >
                  Blogs
                </Link>
              </li>
              <li className="navbar__mobile-menu-item">
                <Link
                  to="/about-us/"
                  className={`navbar__mobile-menu-link ${
                    page === "about-us" ? "navbar__mobile-menu__active" : ""
                  }`}
                >
                  About Us
                </Link>
              </li>
              <li className="navbar__mobile-menu-item">
                <a
                  href="https://support.pulpitcabs.com"
                  className={`navbar__mobile-menu-link ${
                    page === "support" ? "navbar__mobile-menu__active" : ""
                  }`}
                >
                  Support
                </a>
              </li>
              {/* Login → Rider Portal (rider.pulpitcabs.com), a separate app. */}
              <li className="navbar__mobile-menu-item">
                <a
                  href="https://rider.pulpitcabs.com"
                  className="navbar__mobile-menu-link"
                >
                  Login
                </a>
              </li>
            </ul>
          </div>
        )}
        <ul className="navbar__action ">
          {/* <li className="navbar__action-item">
            <Link to="/get-app/" className="navbar__action-link navbar__app">
              <svg className="navbar__app-icon" aria-hidden="true">
                <use href="/sprite.svg#icon-smartphone"></use>
              </svg>
              <span className="navbar__app-text text-[9px] md:text-[14px]">
                Get App
              </span>
            </Link>
          </li> */}
          <li className="navbar__action-item">
            <a
              href="tel:+918052080501"
              className="navbar__action-link navbar__contact"
            >
              <svg className="navbar__contact-icon" aria-hidden="true">
                <use href="/sprite.svg#icon-calling"></use>
              </svg>
              <span className="navbar__contact-text">+91 80520 80501</span>
            </a>
          </li>
          <li className="navbar__action-item">
            <a
              href="https://play.google.com/store/apps/details?id=com.pulpit.pulpit_customer&pcampaignid=web_share&pli=1"
              target="_blank"
              rel="noreferrer"
              className="navbar__action-link navbar__playstore"
            >
              <img
                className="navbar__playstore-icon"
                src="/images/icon-google-play.svg"
                alt="Download Pulpit cab service app from Google Play Store"
              />
              <span className="navbar__playstore-text">Get App</span>
            </a>
          </li>
          {/* Login opens the Rider Portal (rider.pulpitcabs.com) — a separate
              app, so a real anchor, not a react-router <Link>. Replaces the old
              internal /member-login route. */}
          <li className="navbar__action-item">
            <a
              href="https://rider.pulpitcabs.com"
              className="navbar__action-link navbar__login"
            >
              <svg className="navbar__login-icon" aria-hidden="true">
                <use href="/sprite.svg#icon-enter"></use>
              </svg>
              <span className="navbar__login-text">Login</span>
            </a>
          </li>
          <li className="navbar__action-item">
            {!openNavbar && (
              <img
                className="navbar__icon"
                src="/images/icon-navbar-mobile.svg"
                alt="Pulpit mobile navigation menu icon"
                onClick={handleClick}
              />
            )}
            {openNavbar && (
              <svg
                className="navbar__icon"
                aria-hidden="true"
                onClick={handleClick}
              >
                <use href="/sprite.svg#icon-close"></use>
              </svg>
            )}
          </li>
        </ul>
      </div>
    </nav>
  )
}

export default Navbar
